module.exports = __webpack_public_path__ + "static/media/everson.d7c59b8f.jpeg";